import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.page.html',
  styleUrls: ['./landing.page.scss'],
})
export class LandingPage implements OnInit {
  title: string = '`';
  logo_url: string = '';
  footer_title: string = '';
  client = '';
  background_url: string = '';
  datepicker_date_format: string = 'MM/DD/YYYY'
  showNotification: boolean = false;
  login_header_message: string = ''
  login_footer_colour_code: string = ''
  agreement_acceptance: any = {};
  logo_size: string = '60px';
  showInfoIcon = false;
  login_footer_message: string;
  agreement_acceptance_label: string;
   state_disclosures: string;
  showMultipleFieldsMessage: boolean = false;
  full_title_login = null;
  swapFields: {
    primary_field: string;
    secondary_field: string;
    secondary_field_label: string;
  };
  defaultLabels = {
    case_id: 'Case Id',
    case_ref: 'Case Reference',
  };
  checkTranslation = false;
  login_button_label: string;
  
  constructor(
    private router: Router,
    private authService: AuthService) { 
  }

  ngOnInit() {
    this.initializePage();
  }

  private initializePage() {
    // You can add any initialization logic here
    // For example, checking user authentication status
    this.fetchSettings();
  }

  navigateToQuickPay() {
    this.router.navigate(['/quick-pay']);
  }

  navigateToLogin() {
    this.router.navigate(['/login'], { queryParams: { dynamic: '1' } });
  }

   fetchSettings() {
    this.authService.portalSettings2().subscribe((res: any) => {
      let portalSettings = res.data;
    
      if (portalSettings?.portal_details?.title) {
        this.title = portalSettings.portal_details.title;
        var domain = new URL(localStorage.getItem('server_url')).hostname.split(
          '.'
        )[0];
        this.client = domain.charAt(0).toUpperCase() + domain.slice(1);
      }

      if (portalSettings?.portal_details?.logo_url) {
        this.logo_url = portalSettings.portal_details.logo_url;
      }
      if (portalSettings?.portal_details?.login_logo_url) {
        this.logo_url = portalSettings.portal_details.login_logo_url;
      }
      if (portalSettings?.portal_details?.background_url) {
        this.background_url = portalSettings.portal_details.background_url;
      }
      if (portalSettings?.datepicker_date_format) {
        this.datepicker_date_format = portalSettings.datepicker_date_format;
      }
      if (portalSettings?.additional_settings?.custom_notifications?.show_notification_panel) {
        this.showNotification = portalSettings.additional_settings.custom_notifications.show_notification_panel;
      }

      //'Having trouble signing in' message. - LU-254
      this.login_header_message = portalSettings?.portal_details?.login_header_message;
      this.login_footer_colour_code = portalSettings?.portal_details?.login_footer_colour_code;
      this.agreement_acceptance = portalSettings?.portal_details?.agreement_acceptance_checkbox;

       if (localStorage.getItem('language') != 'en') {
        console.log(portalSettings?.portal_details);
        console.log(portalSettings?.portal_details?.['agreement_acceptance_label_' + localStorage.getItem('language')]);
        this.agreement_acceptance_label = portalSettings?.portal_details?.['agreement_acceptance_label_' + localStorage.getItem('language')] || portalSettings?.portal_details?.agreement_acceptance_label;
        this.login_footer_message = portalSettings?.portal_details?.['login_footer_message_' + localStorage.getItem('language')] || portalSettings?.portal_details?.login_footer_message;
        this.state_disclosures = portalSettings?.additional_settings?.state_disclosures?.['state_disclosures_' + localStorage.getItem('language')] || portalSettings?.additional_settings?.state_disclosures?.state_disclosures || '';
        this.full_title_login = portalSettings?.portal_details?.['full_title_' + localStorage.getItem('language')] ||  portalSettings?.portal_details?.full_title;
        this.login_button_label = portalSettings?.portal_details?.['login_button_label_' + localStorage.getItem('language')] || portalSettings?.portal_details?.login_button_label;
      }
      else {
        this.agreement_acceptance_label = portalSettings?.portal_details?.agreement_acceptance_label;
        this.login_footer_message = portalSettings?.portal_details?.login_footer_message;
        this.state_disclosures = portalSettings?.additional_settings?.state_disclosures?.state_disclosures;
        this.full_title_login = portalSettings?.portal_details?.full_title;
        this.login_button_label = portalSettings?.portal_details?.login_button_label;
        console.log(this.login_button_label);
      }
      this.logo_size = portalSettings?.portal_details?.logo_size || '120px';
      
      // Apply theme settings
      if (portalSettings?.theme_settings) {
        this.applyTheme(portalSettings.theme_settings);
      }
    });
  }

  applyTheme(themeSettings: any) {
    const root = document.documentElement;

    // Iterate through the theme settings and set CSS variables
    for (const panelKey in themeSettings) {
      if (themeSettings.hasOwnProperty(panelKey)) {
        const colors = themeSettings[panelKey];
        for (const colorKey in colors) {
          if (colors.hasOwnProperty(colorKey)) {
            const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            const target = isDark ? document.body : document.documentElement;
            target.style.setProperty(`--${colorKey.replace(/_/g, '-')}`, colors[colorKey]);
          }
        }
      }
    }
  }
}
